import { useIntl } from 'react-intl'
import LineCheckIcon from 'LuxKit/Icons/line/LineCheckIcon'
import IconInCircle from 'tripPlanner/components/Icons/IconInCircle'
import { SuccessHeader, Title } from './shared'

function SuccessStep() {
  const intl = useIntl()

  return (
    <SuccessHeader>
      <IconInCircle icon={LineCheckIcon} circleColour="success" iconColour="neutral-eight" size={24} />
      <Title>{intl.formatMessage({
        id: 'BkhYjd9HtfEiOYomZQvV',
        defaultMessage: 'You’re logged in',
        description: 'Success title for embedded trip planner account access widget',
      })}
      </Title>
    </SuccessHeader>
  )
}

export default SuccessStep
